import { IncentivesMarketContextType } from '../types/IncentivesMarketContextType';

export const incentivesMarketInitValue: IncentivesMarketContextType = {
  data: {
    societyId: '',
    societyName: '',
    beneficiaryShares: {
      total: 0,
      acquisitionValue: 0,
      avgAcquisitionPrice: 0,
      estimatedValue: 0,
      valueChange: 0,
    },
    beneficiaryActiveOffers: {
      total: 0,
      sellCount: 0,
      buyCount: 0,
      sellAmount: 0,
      buyAmount: 0,
    },
    beneficiaryOperations: {
      total: 0,
      sellCount: 0,
      buyCount: 0,
      sellAmount: 0,
      buyAmount: 0,
    },
    marketInfo: {
      totalOffers: 0,
      sellCount: 0,
      buyCount: 0,
      sellAmount: 0,
      buyAmount: 0,
    },
    sellOffers: [],
    buyOffers: [],
    sellOffersSummary: {
      offersCount: 0,
      unitsCount: 0,
      totalAmount: 0,
    },
    buyOffersSummary: {
      offersCount: 0,
      unitsCount: 0,
      totalAmount: 0,
    },
    recentActivity: [],
    referenceInfo: {
      lastValuation: 0,
      lastValuationDate: '',
      totalShares: 0,
      lastTransactionPrice: 0,
      lastTransactionDate: '',
      activeBeneficiariesInMarket: 0,
    },
    isAdmin: false,
    isBeneficiary: false,
    isReadOnly: false,
    isLoading: true,
    isMarketClosed: false,
  },
  actions: {
    handleCreateSellOffer: () => {},
    handleCreateBuyOffer: () => {},
    handleViewSellOffers: () => {},
    handleViewBuyOffers: () => {},
    handleViewOfferDetail: () => {},
    handleViewMyShares: () => {},
    handleViewMyOffers: () => {},
    handleViewMyOperations: () => {},
    handleOpenHowItWorks: () => {},
  },
};
